import Vue from 'vue'
import Vuex from 'vuex'
import alerts from './modules/alerts'
import drawers from './modules/drawers'
import snackbar from './modules/snack-bar'
import customers from './modules/customers'
import documents from './modules/documents'
import tasks from './modules/tasks'
import users from './modules/users'
import events from './modules/events'
import eventItems from './modules/eventItems'
import eventGroups from './modules/eventGroups'
import auth from './modules/auth'
import divisions from './modules/divisions'
import groups from './modules/groups'
import signup from './modules/signup'
import tenants from './modules/tenants'
import crons from './modules/crons'
import coupons from './modules/coupons'
import subscriptions from './modules/subscriptions'
import invoices from './modules/invoices'
import invoiceItems from './modules/invoiceItems'
import services from './modules/services'
import balance from './modules/balance'
import payouts from './modules/payouts'
import disputes from './modules/disputes'
import payments from './modules/payments'
import serviceWorker from './modules/serviceWorker'
import plans from './modules/plans'
import customerSources from './modules/customerSources'
import customerBalances from './modules/customerBalances'
import customerDiscount from './modules/customerDiscount'
import refunds from './modules/refunds'
import taxRates from './modules/taxRates'
import orders from './modules/orders'
import account from './modules/account'
import accountOwner from './modules/accountOwner'
import externalAccounts from './modules/externalAccounts'
import files from './modules/files'
import publicState from './modules/public'
import cart from './modules/cart'
import products from './modules/products'
import productVariants from './modules/productVariants'
import platform from './modules/platform'
import tokens from './modules/tokens'
import templates from './modules/templates'
import scheduleGroups from './modules/scheduleGroups'
import shifts from './modules/shifts'
import bookings from './modules/bookings'
import storage from './modules/storage'
import customerPaymentMethods from './modules/customerPaymentMethods'

Vue.use(Vuex);

/**
 * Any Modules that you want cleared when the user changes session
 * should be listed here. Their initial state should always be defined within
 * the module itself.
 */
const initialState = {
  divisions: { ...divisions.state },
  groups: { ...groups.state },
  events: { ...events.state },
  eventItems: { ...eventItems.state },
  eventGroups: { ...eventGroups.state },
  users: { ...users.state },
  crons: { ...crons.state },
  tasks: { ...tasks.state },
  coupons: { ...coupons.state },
  subscriptions: { ...subscriptions.state },
  invoices: { ...invoices.state },
  invoiceItems: { ...invoiceItems.state },
  services: { ...services.state },
  balance: { ...balance.state },
  payouts: { ...payouts.state },
  disputes: { ...disputes.state },
  payments: { ...payments.state },
  serviceWorker: { ...serviceWorker.state },
  plans: { ...plans.state },
  customerSources: { ...customerSources.state },
  customerBalances: { ...customerBalances.state },
  customerDiscount: { ...customerDiscount.state },
  refunds: { ...refunds.state },
  taxRates: { ...taxRates.state },
  orders: { ...orders.state },
  account: { ...account.state },
  accountOwner: { ...account.state },
  externalAccounts: { ...externalAccounts.state },
  files: { ...files.state },
  public: { ...publicState.state},
  cart: { ...cart.state },
  products: { ...products.state },
  productVariants: { ...productVariants.state },
  platform: { ...platform.state },
  tokens: { ...tokens.state },
  templates: { ...templates.state },
  scheduleGroups: { ...scheduleGroups.state },
  shifts: { ...shifts.state },
  bookings: { ...bookings.state },
  storage: { ...storage.state },
  customerPaymentMethods: { ...customerPaymentMethods.state }
}

export default new Vuex.Store({
  modules: {
    alerts,
    auth,
    tasks,
    drawers,
    snackbar,
    customers,
    documents,
    users,
    events,
    eventItems,
    eventGroups,
    divisions,
    groups,
    signup,
    tenants,
    crons,
    coupons,
    subscriptions,
    invoices,
    invoiceItems,
    services,
    balance,
    payouts,
    disputes,
    payments,
    serviceWorker,
    plans,
    customerSources,
    customerBalances,
    customerDiscount,
    refunds,
    taxRates,
    orders,
    account,
    accountOwner,
    externalAccounts,
    files,
    publicState,
    cart,
    products,
    productVariants,
    platform,
    tokens,
    templates,
    scheduleGroups,
    shifts,
    bookings,
    storage,
    customerPaymentMethods
  },
  state: {
    isLoading: false, // This is a global loading state to be used when API calls are being made
    isAppLoading: false,
    isPublic: false,
  },
  getters: {
    isLoading(state){
      return state.isLoading
    },
    isAppLoading(state) {
      return state.isAppLoading
    },
  },
  actions: {
    setIsPlatform({ commit }, value) {
      commit('SET_IS_PLATFORM', value)
    },
    setIsPublic({ commit }, value) {
      commit('SET_IS_PUBLIC', value)
    },
    resetState({ commit }) {
      commit('reset')
    },
    startAppLoading({ commit }) {
      commit('UPDATE_APP_LOADING', true)
    },
    stopAppLoading({ commit }) {
      commit('UPDATE_APP_LOADING', false)
    },
    startApiLoading({ commit }) {
      commit('UPDATE_API_LOADING', true)
    },
    stopApiLoading({ commit }) {
      commit('UPDATE_API_LOADING', false)
    }
  },
  mutations: {
    SET_IS_PUBLIC(state, value) {
      state.isPublic = !!value
    },
    reset (state) {
      Object.keys(state).forEach(key => {
        state[key] = { ...state[key], ...initialState[key] }
      })
    },
    UPDATE_API_LOADING(state, value) {
      state.isLoading = !!value;
    },
    UPDATE_APP_LOADING(state, value) {
      state.isAppLoading = !!value;
    }
  },
});
